




























































































import { Component, Vue } from "vue-property-decorator";
import TokenUtil from "@/utils/TokenUtil";
import AuthModule from "@/store/auth";
import ConversationsApi from "@/services/Conversations";
import MessagesApi from "@/services/Messages";
import VueRouter, { NavigationGuardNext } from "vue-router";
import { Conversation } from "@/api/lab-base-api-client";
import { io } from "socket.io-client";

@Component
export default class OLoginHeader extends Vue {
  // メニューリストの非表示
  private menuList = false;

  // メニューリストを押したときのv-show切り替え
  private active() {
    this.menuList = !this.menuList;
  }

  // チャット通知
  private notice = 0;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private adminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";

  private chatAdminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";

  private socket = io(
    `${process.env?.NODE_ENV === "development" ? "http://localhost:3000" : process.env.VUE_APP_SOCKET_URL}`,
    {
      withCredentials: true,
      path: `${process.env?.NODE_ENV === "development" ? "" : "/api/socket.io"}`,
    }
  );

  private async mounted() {
    this.socket.on("sendConversationUuid", () => {
      if (this.$route.name !== "OChat") {
        this.fetchNotice();
      }
    });
    if (this.$route.name !== "OChat") {
      await this.fetchNotice();
    }
  }

  // 通知の取得
  private async fetchNotice() {
    if (this.me && "organizationUuid" in this.me) {
      const conversationsRes = await ConversationsApi.instance.getConversationByOrganizationAdminUuid(
        this.me.organizationUuid
      );

      const conversations = conversationsRes.data.data.items;

      const conversationsUuids = conversations.map((conversation: Conversation) => {
        return conversation.uuid;
      });

      if (conversations.length) {
        const getNewMessageCountRes = await MessagesApi.instance.getNewMessageCount(this.chatAdminUuid, {
          conversationUuids: conversationsUuids,
        });

        this.notice = getNewMessageCountRes.data.data.count;
      }
    }
  }

  // queryの変更で実行
  async beforeRouteUpdate(to: VueRouter, from: VueRouter, next: NavigationGuardNext) {
    // 最新のチャットを表示
    await next();
    await this.fetchNotice();
  }

  // チャットクリック
  private clickChat() {
    this.$router.push({ name: "OChat" });
    this.notice = 0;
  }

  // ログアウト処理
  private logout() {
    TokenUtil.removeToken();
    AuthModule.commitMe(null);
    // ログアウトと同時にトップページに戻る
    this.$router.push("/");
  }
}
